import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

import {AuthUser, TokenService} from '../../../../core/auth';
import {User} from '../../../../core/models';
import {UserService} from '../../../../core/services';
import {BreadcrumbService} from '../../../../breadcrumb.service';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.page.html',
  styleUrls: ['./user-details.page.css']
})
export class UserDetailsPage implements OnInit {
  @Input() user: User;
  userOrig: User;
  saving = false;
  loading = false;
  authUser: AuthUser = this.token.whoAmI();
  // availableRoles: Role[];
  // selectedRoles = {};
  id;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private token: TokenService,
    private breadcrumbService: BreadcrumbService
  ) {
  }

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id');

    this.loadUser(this.id);

  }

  setLoading(bool) {
    this.loading = bool;
  }


  loadUser(id) {
    this.setLoading(true);
    this.userService.getOne(id)
      .subscribe(
        (user) => {
          this.userOrig = user;
          this.user = user;
          this.setLoading(false);
          this.breadcrumbService.setItems([
            {label: 'admin', routerLink: ['/admin']},
            {label: 'user', routerLink: ['/admin', 'user', 'list']},
            {label: this.user.name}
          ]);
        },
        (error) => {
          this.setLoading(false);
        }
      );
  }


}
